import React from 'react';

/* Styles */
//import styles from './Splash.module.css';

/* Images */
import letter from '../../assets/img/letters_splash.svg';
import arrow  from '../../assets/img/arrow_splash.png';

/* Wrapper */
import WrapperConsumer from '../../store';

const Splash = (props) => {
    

    const viewLogin = () => {
        window.location = "/login";
    }
    
   setTimeout(viewLogin, 5000);

    return(
        <div className='flex justify-center items-center h-screen animate-pulse'>

            <div className='flex flex-col '>
                <div>
                    <img src={arrow} className='block m-auto mt-24 ' alt="META" />
                </div>
                <div>
                    <img src={letter} className='block m-auto mt-24 mb-10' alt="META" />
                </div>
                
            </div>

        </div>
    )
}
export default WrapperConsumer(Splash)